import React, { useState } from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import BackgroundImage from "../../2-utils/BackgroundImage";
import ThailandImage from "../../3-assets/images/thailand/phiphi/island.jpg";
import VietnamImage from "../../3-assets/images/vietnam/sapa/rice-planter.jpg";
import BaliImage from "../../3-assets/images/bali/mountbatur/sunrise-right.jpg";
import GermanyImage from '../../3-assets/images/germany/rothenburg/viewpoint.jpg'
import HungaryImage from '../../3-assets/images/hungary/synagogue.jpg'
import LaosImage from "../../3-assets/images/laos/nong khiaow/pha-daeng-peak.jpg";
import AnimatedPlane from "./animated-plane";

const countryToImage = {
  thailand: ThailandImage,
  vietnam: VietnamImage,
  bali: BaliImage,
  laos: LaosImage,
  hungary: HungaryImage,
  germany: GermanyImage
};

const countries = ["thailand", "vietnam", "bali", "laos", "hungary", "germany"];

export default function() {
  const [country, setCountry] = useState("");
  return (
    <BackgroundImageWithStyling src={countryToImage[country]}>

      {!country && <AnimatedPlane />}
    
      {countries.map(country => (
        <Option
          onMouseEnter={() => setCountry(country)}
          onMouseLeave={() => setCountry("")}
          to={`map/${country}`}
        >
          {country}
        </Option>
      ))}

    </BackgroundImageWithStyling>
  );
}

const BackgroundImageWithStyling = styled(BackgroundImage)`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ src }) => (src ? "white" : "black")};
  @media (max-width: 600px) {
    flex-direction: column;
    padding-top: 1em;
  }
`;

const Option = styled(Link)`
  font-size: 24px;
  padding: 0.3em 0.5em;
  transition: 0.2s ease;
  text-transform: lowercase;
  border-radius: 100px;
	color: black;
	text-decoration: none;
  &:hover {
    cursor: pointer;
    color: black;
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: var(--shadow-1);
  }
`;
